"use strict"; // Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0

var _regeneratorRuntime = require("/codebuild/output/src32004911/src/node_modules/babel-preset-react-app/node_modules/@babel/runtime/regenerator");

var _classCallCheck = require("/codebuild/output/src32004911/src/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/codebuild/output/src32004911/src/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createClass");

var _createSuper = require("/codebuild/output/src32004911/src/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createSuper");

var _inherits = require("/codebuild/output/src32004911/src/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/inherits");

var __awaiter = this && this.__awaiter || function (thisArg, _arguments, P, generator) {
  function adopt(value) {
    return value instanceof P ? value : new P(function (resolve) {
      resolve(value);
    });
  }

  return new (P || (P = Promise))(function (resolve, reject) {
    function fulfilled(value) {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    }

    function rejected(value) {
      try {
        step(generator["throw"](value));
      } catch (e) {
        reject(e);
      }
    }

    function step(result) {
      result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
    }

    step((generator = generator.apply(thisArg, _arguments || [])).next());
  });
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var MeetingSessionStatusCode_1 = require("../meetingsession/MeetingSessionStatusCode");

var DefaultSDP_1 = require("../sdp/DefaultSDP");

var BaseTask_1 = require("./BaseTask");
/*
 * [[FinishGatheringICECandidatesTask]] add ice-candidate event handler on peer connection to
 * collect ice candidates and wait for peer connection ice gathering state to complete
 */


var FinishGatheringICECandidatesTask = /*#__PURE__*/function (_BaseTask_1$default) {
  _inherits(FinishGatheringICECandidatesTask, _BaseTask_1$default);

  var _super = _createSuper(FinishGatheringICECandidatesTask);

  function FinishGatheringICECandidatesTask(context) {
    var _this;

    var chromeVpnTimeoutMs = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : FinishGatheringICECandidatesTask.CHROME_VPN_TIMEOUT_MS;

    _classCallCheck(this, FinishGatheringICECandidatesTask);

    _this = _super.call(this, context.logger);
    _this.context = context;
    _this.chromeVpnTimeoutMs = chromeVpnTimeoutMs;
    _this.taskName = 'FinishGatheringICECandidatesTask';
    return _this;
  }

  _createClass(FinishGatheringICECandidatesTask, [{
    key: "removeEventListener",
    value: function removeEventListener() {
      if (this.context.peer) {
        this.context.peer.removeEventListener('icecandidate', this.context.iceCandidateHandler);

        if (!this.context.turnCredentials) {
          this.context.peer.removeEventListener('icegatheringstatechange', this.context.iceGatheringStateEventHandler);
        }
      }
    }
  }, {
    key: "cancel",
    value: function cancel() {
      var error; // TODO: Remove when the Chrome VPN reconnect bug is fixed.
      // In Chrome, SDK may fail to establish TURN session after VPN reconnect.
      // https://bugs.chromium.org/p/webrtc/issues/detail?id=9097

      if (this.context.browserBehavior.requiresIceCandidateGatheringTimeoutWorkaround()) {
        if (this.chromeVpnTimeoutMs < this.context.meetingSessionConfiguration.connectionTimeoutMs) {
          var duration = Date.now() - this.startTimestampMs;

          if (duration > this.chromeVpnTimeoutMs) {
            error = new Error("canceling ".concat(this.name(), " due to the meeting status code: ").concat(MeetingSessionStatusCode_1.default.ICEGatheringTimeoutWorkaround));
          }
        }
      } // Just in case. The baseCancel behavior should prevent this.

      /* istanbul ignore else */


      if (this.cancelPromise) {
        error = error || new Error("canceling ".concat(this.name()));
        this.cancelPromise(error);
        delete this.cancelPromise;
      }
    }
  }, {
    key: "run",
    value: function run() {
      return __awaiter(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
        var _this2 = this;

        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                if (!this.context.peer) {
                  this.logAndThrow("session does not have peer connection; bypass ice gathering");
                }

                if (!this.context.browserBehavior.requiresCheckForSdpConnectionAttributes()) {
                  _context.next = 7;
                  break;
                }

                if (!new DefaultSDP_1.default(this.context.peer.localDescription.sdp).hasCandidatesForAllMLines()) {
                  _context.next = 5;
                  break;
                }

                this.context.logger.info("ice gathering already complete; bypass gathering, current local description ".concat(this.context.peer.localDescription.sdp));
                return _context.abrupt("return");

              case 5:
                _context.next = 8;
                break;

              case 7:
                this.context.logger.info("iOS device does not require checking for connection attributes in SDP, current local description ".concat(this.context.peer.localDescription.sdp));

              case 8:
                if (!((this.context.browserBehavior.hasFirefoxWebRTC() || this.context.peer.iceGatheringState === 'complete') && new DefaultSDP_1.default(this.context.peer.localDescription.sdp).hasCandidates())) {
                  _context.next = 11;
                  break;
                }

                this.context.logger.info('ice gathering state is complete and candidates are in SDP; bypass gathering');
                return _context.abrupt("return");

              case 11:
                _context.prev = 11;
                _context.next = 14;
                return new Promise(function (resolve, reject) {
                  _this2.cancelPromise = function (error) {
                    _this2.removeEventListener();

                    reject(error);
                  };

                  if (!_this2.context.turnCredentials) {
                    // if one day, we found a case where a FinishGatheringICECandidate did not resolve but ice gathering state is complete and SDP answer has ice candidates
                    // we may need to enable this
                    _this2.context.iceGatheringStateEventHandler = function () {
                      if (_this2.context.peer.iceGatheringState === 'complete') {
                        _this2.removeEventListener();

                        resolve();
                        delete _this2.cancelPromise;
                        return;
                      }
                    };

                    _this2.context.peer.addEventListener('icegatheringstatechange', _this2.context.iceGatheringStateEventHandler);
                  }

                  _this2.context.iceCandidateHandler = function (event) {
                    _this2.context.logger.info("ice candidate: ".concat(event.candidate ? event.candidate.candidate : '(null)', " state: ").concat(_this2.context.peer.iceGatheringState)); // Ice candidate arrives, do not need to wait anymore.
                    // https://webrtcglossary.com/trickle-ice/


                    if (event.candidate) {
                      if (DefaultSDP_1.default.isRTPCandidate(event.candidate.candidate)) {
                        _this2.context.iceCandidates.push(event.candidate);
                      } // Could there be a case the candidate is not written to SDP ?


                      if (_this2.context.turnCredentials && _this2.context.iceCandidates.length >= 1) {
                        _this2.context.logger.info('gathered at least one relay candidate');

                        _this2.removeEventListener();

                        resolve();
                        delete _this2.cancelPromise;
                        return;
                      }
                    } // Ice candidate gathering is complete, additional barrier to make sure sdp contain an ice candidate.
                    // TODO: Could there be a race where iceGatheringState is flipped after this task is run ? This could only be handled if ice state is monitored persistently.


                    if (_this2.context.peer.iceGatheringState === 'complete') {
                      _this2.context.logger.info('done gathering ice candidates');

                      _this2.removeEventListener();

                      if (!new DefaultSDP_1.default(_this2.context.peer.localDescription.sdp).hasCandidates() || _this2.context.iceCandidates.length === 0) {
                        reject(new Error('no ice candidates were gathered'));
                        delete _this2.cancelPromise;
                      } else {
                        resolve();
                        delete _this2.cancelPromise;
                      }
                    }
                  }; // SDK does not catch candidate itself and send to sever. Rather, WebRTC handles candidate events and writes candidate to SDP.


                  _this2.context.peer.addEventListener('icecandidate', _this2.context.iceCandidateHandler);

                  _this2.startTimestampMs = Date.now();
                });

              case 14:
                _context.next = 19;
                break;

              case 16:
                _context.prev = 16;
                _context.t0 = _context["catch"](11);
                throw _context.t0;

              case 19:
                _context.prev = 19;

                /* istanbul ignore else */
                if (this.startTimestampMs) {
                  this.context.iceGatheringDurationMs = Math.round(Date.now() - this.startTimestampMs);
                }

                return _context.finish(19);

              case 22:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this, [[11, 16, 19, 22]]);
      }));
    }
  }]);

  return FinishGatheringICECandidatesTask;
}(BaseTask_1.default);

exports.default = FinishGatheringICECandidatesTask;
FinishGatheringICECandidatesTask.CHROME_VPN_TIMEOUT_MS = 5000;